import { getApiErrorMessage } from '@/utils/apiError';

// Renders the structured 409 GLASS_TYPE_IN_USE response (single + bulk delete) as a
// readable message with the usage details the server was willing to disclose.
export const describeGlassTypeConflict = (error, fallback = 'Failed to delete glass type') => {
  const detail = error?.response?.data?.detail;
  if (error?.response?.status === 409 && detail && typeof detail === 'object' && detail.code === 'GLASS_TYPE_IN_USE') {
    if (Array.isArray(detail.blocked)) {
      const names = detail.blocked
        .map((b) => `${b.glassTypeName || b.glassTypeId} (${b.usageCount} record${b.usageCount === 1 ? '' : 's'})`)
        .join(', ');
      return `${detail.message} In use: ${names}. Nothing was deleted - adjust your selection and try again.`;
    }
    const usages = (detail.usages || []).slice(0, 5)
      .map((u) => `${u.division}: ${u.label || u.recordId}`)
      .join(', ');
    const more = (detail.usageCount || 0) > 5 ? ` and ${detail.usageCount - 5} more` : '';
    return usages ? `${detail.message} Used by ${usages}${more}.` : detail.message;
  }
  return getApiErrorMessage(error, fallback);
};

export const isGlassTypeConflict = (error) =>
  error?.response?.status === 409 && error?.response?.data?.detail?.code === 'GLASS_TYPE_IN_USE';
